import $ from 'jquery';

$(function () {
  if ($('.unsubscriptions').length) {
    $.post(window.location.pathname, function () {
      $('.unsub-form').addClass('hidden');
      $('.unsub-success').removeClass('hidden');
    });
  }
});
